import $ from 'jquery';
import prestashop from 'prestashop';

function showClassicBlockCartModal(html) {
    document.getElementById('blockcart-modal')?.remove();

    document.body.insertAdjacentHTML('beforeend', html);

    const modal = document.getElementById('blockcart-modal');

    if (!modal) {
        return;
    }

    const closeModal = () => {
        modal.remove();
        document.body.classList.remove('overflow-hidden');
    };

    modal.querySelectorAll('[data-dismiss="blockcart-modal"]').forEach((element) => {
        element.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeModal();
        }
    });

    document.body.classList.add('overflow-hidden');
}

function replaceBlockcartPreview(previewHtml) {
    if (!previewHtml) {
        return;
    }

    const $replacement = $('<div>').append($.parseHTML(previewHtml)).find('.blockcart').first();

    if ($replacement.length) {
        $('.blockcart').first().replaceWith($replacement);
    }
}

function fetchClassicBlockcartModal(cartResponse) {
    let refreshURL = $('.blockcart').data('refresh-url');

    if (!refreshURL) {
        return;
    }

    if (refreshURL.startsWith('//')) {
        refreshURL = `${window.location.protocol}${refreshURL}`;
    }

    $.post(refreshURL, {
        id_customization: cartResponse.id_customization || 0,
        id_product_attribute: cartResponse.id_product_attribute,
        id_product: cartResponse.id_product,
        action: 'add-to-cart',
    }).then((resp) => {
        replaceBlockcartPreview(resp.preview);

        if (resp.modal) {
            showClassicBlockCartModal(resp.modal);
        }
    }).fail((resp) => {
        prestashop.emit('handleError', { eventType: 'updateShoppingCart', resp });
    });
}

export function handleClassicAddToCartSuccess(resp) {
    if (!document.querySelector('.js-classic-product-page')) {
        return;
    }

    if (!resp || resp.hasError || resp.success === false) {
        return;
    }

    fetchClassicBlockcartModal(resp);
}

prestashop.blockcart = prestashop.blockcart || {};

// Fallback for ps_shoppingcart.js if it resolves showModal after theme load.
prestashop.blockcart.showModal = (html) => {
    if (!document.querySelector('.js-classic-product-page')) {
        return;
    }

    showClassicBlockCartModal(html);
};
